import React from 'react';
import { useDispatch } from 'react-redux';
import { fontSize, palette } from '../../../..';
import { FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { PatternCollectionType } from '../../../ChartFieldFilter/UserFilterCardInterface';
import {
  removeParameterRightOperand,
  updateFilterOperator,
} from '../../../../redux/Calculations/CalculationsActions';
import { CanvasSelect } from '../../common/CanvasSelect';
interface OperatorProps {
  propKey: string;
  conditionFilterId: string;
  filterIdx: number;
  operator: string;
  disabled?: boolean;
  operators: PatternCollectionType[];
}

const Operator = React.memo(
  ({ propKey, conditionFilterId, filterIdx, operator, disabled, operators }: OperatorProps) => {
    const dispatch = useDispatch();
    const handleOperatorChange = (event: SelectChangeEvent<string>) => {
      if (disabled) return;
      const selectedOperator = event.target.value;
      dispatch(updateFilterOperator(propKey, conditionFilterId, filterIdx, selectedOperator));
    };
    if (!operators) return null;

    const selectedOperator =
      operators?.find((op) => op.key === operator) ?? null;

    return (
      <CanvasSelect<PatternCollectionType>
        value={selectedOperator}
        options={operators}
        getLabel={(opt) => opt.value}
        getKey={(opt) => opt.key}
        onChange={(opt) => {
          if (disabled) return;
          dispatch(
            updateFilterOperator(
              propKey,
              conditionFilterId,
              filterIdx,
              opt.key
            )
          );
        }}
        disabled={disabled}
        style={{
          height: '1.5rem',
          fontSize: fontSize.large,
        }}
      />

    );
  },
);

export default Operator;
